import { RouteConfig } from "vue-router";

import AuthLayout from "@/layout/AuthLayout.vue";
import { ifNotAuthenticated } from "./utils";

export const authRoutes: Array<RouteConfig> = [
  {
    path: "/",
    // redirect: "",
    component: AuthLayout,
    beforeEnter: ifNotAuthenticated,
    children: [
      { path: "/", redirect: "/login" },
      {
        path: "login",
        name: "login",
        component: () => import("@/views/auth/Login.vue")
      },
      {
        path: "register",
        name: "register",
        component: () => import("@/views/auth/Register.vue")
      },
      {
        path: "forgot",
        name: "forgot",
        component: () => import("@/views/auth/ForgotPassword.vue")
      },
      {
        path: "reset-password",
        name: "reset",
        component: () => import("@/views/auth/ResetPassword.vue")
      }
    ]
  }
];
